<template>
  <h2>
    <slot></slot>
  </h2>
</template>
<script>

export default {
  name: "m-h2",
};
</script>

<style scoped>
h2 {
  color: var(--dark);
}
</style>